import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FormAction.scss';
/**
 * @component FormAction
 * @since 1.0.0
 */
export function FormAction(props) {
    const { style, align } = Object.assign({ style: 'normal', align: 'end' }, props);
    const className = classNames('form-action', 'form-action--' + style, 'form-action--' + align, props.className);
    return React.createElement("div", { className: className }, props.children);
}
